import {
  EditContextProvider,
  Form,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../../resource';
import WithdrawConfigForm from './WithdrawConfigForm';
import {
  updateRedPacketConfig,
  RedPacketConfig,
} from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const EditRedPacketConfig = ({
  id,
  onClose,
  record,
}: {
  id: string | number;
  onClose: () => void;
  record?: RedPacketConfig;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.redpacket,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify('update successful', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'update failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        const configKey = record?.configKey || controller.record?.configKey ;
        await updateRedPacketConfig({
          configKey: configKey,
          value: String(data.value),
          reason: `update ${configKey} configuration`,
        });
        notify('UpdateSuccessful', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'UpdateFailed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  if (controller.isLoading || (!controller.record && !record)) return null;

  const currentRecord = record || controller.record;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification defaultValues={currentRecord}>
        <DialogTitle>Edit {currentRecord?.configKey}</DialogTitle>
        <DialogContent>
          <WithdrawConfigForm isCreate={false} record={record} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="update">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditRedPacketConfig;
